module.exports = __webpack_public_path__ + "static/media/figtree-latin-400.307f463f.woff2";